<template>
  <div>
    <!-- Hack to cover left sidebar -->
    <v-overlay class="sidebar-cover-overlay" v-if="show">
      <div class="sidebar-cover-clickable"></div>
    </v-overlay>

    <v-dialog v-model="show" :width="width" :dark="dark">
      <v-card>
        <v-card-title class="px-3">{{ title }}</v-card-title>
        <v-divider></v-divider>
        <v-container>
          <slot></slot>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            style="margin: auto;"
            text
            @click="show = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "SimpleDialog",
  props: {
    open: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    width: {
      type: Number,
      default: 900,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      show: false,
    };
  },
  watch: {
    open() {
      this.show = true;
    },
  },
};
</script>

<style scoped>
.sidebar-cover-overlay.v-overlay {
  left: 0 !important;
}
.sidebar-cover-clickable {
  width: 100vw;
  height: 100vh;
}
</style>
